/**
 * FlashAutoDismiss Hook
 *
 * Auto-dismisses flash notifications after a delay with animation.
 * Replaces Alpine.js x-init for this single use case.
 */

const DISMISS_DELAY_MS = 4000
const ANIMATION_DURATION_MS = 500

/**
 * Schedules the flash element for dismissal with slide-out animation.
 */
const scheduleDismiss = (el: HTMLElement): number =>
  window.setTimeout(() => {
    el.classList.remove('slideInDown')
    el.classList.add('slideOutUp')

    // Trigger click to clear flash after animation completes
    window.setTimeout(() => el.click(), ANIMATION_DURATION_MS)
  }, DISMISS_DELAY_MS)

export const FlashAutoDismiss = {
  mounted(this: { el: HTMLElement; dismissTimeout?: number }) {
    this.dismissTimeout = scheduleDismiss(this.el)
  },

  destroyed(this: { dismissTimeout?: number }) {
    if (this.dismissTimeout) {
      window.clearTimeout(this.dismissTimeout)
    }
  }
}
